import useIsCorpView from "./useIsCorpView"
import { useAppSelector } from "../redux/store"
import { selectTeamMembers } from "../redux/customer"
import { selectChildTeamMembers } from "../redux/childCustomer"

const useTeamMembers = () => {
  const isCorpView = useIsCorpView()
  
  const teamMembers = isCorpView
    ? useAppSelector(selectChildTeamMembers)
    : useAppSelector(selectTeamMembers)

  return teamMembers ?? []
}

export default useTeamMembers
